import { IntlShape } from "react-intl";
import { getUIHostUrl } from "../../../utils";
import { iconCdcm } from "../icons";
const CDCM_URL = getUIHostUrl();

export const getAppSwitcherMenuItems = (
  intl: IntlShape,
): Array<{
  avatarProps: {
    label: string;
    src: string;
  };
  href: string;
  id: string;
  label: string;
  onClick: () => void;
}> => [
  {
    avatarProps: {
      label: intl.formatMessage({
        id: "cdcm.header.home",
        defaultMessage: "Setups",
      }),
      src: iconCdcm,
    },
    href: "",
    id: "option-1",
    label: intl.formatMessage({
      id: "cdcm.header.home",
      defaultMessage: "Setups",
    }),
    onClick: (): string => (window.location.href = CDCM_URL),
  },
];
